import { useLanguage } from '@vocab/react';

import type { Maintenance } from '../../context/MaintenanceProvider';

import { getMessageFromMaintenance } from './messageUtils';

const useMaintenanceMessage = () => {
  const { language } = useLanguage();

  const getMessage = (maintenance?: Maintenance) =>
    getMessageFromMaintenance(language, maintenance);

  return { getMessage };
};

export default useMaintenanceMessage;
